'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  // Northeast
  Connecticut: 'Northeast',
  Maine: 'Northeast',
  Massachusetts: 'Northeast',
  'New Hampshire': 'Northeast',
  'Rhode Island': 'Northeast',
  Vermont: 'Northeast',
  'New Jersey': 'Northeast',
  'New York': 'Northeast',
  Pennsylvania: 'Northeast',
  // Midwest
  Indiana: 'Midwest',
  Illinois: 'Midwest',
  Ohio: 'Midwest',
  Michigan: 'Midwest',
  Iowa: 'Midwest',
  Wisconsin: 'Midwest',
  Minnesota: 'Midwest',
  Kansas: 'Midwest',
  Nebraska: 'Midwest',
  Missouri: 'Midwest',
  'South Dakota': 'Midwest',
  'North Dakota': 'Midwest',
  // South
  Delaware: 'South',
  Florida: 'South',
  Georgia: 'South',
  Maryland: 'South',
  'North Carolina': 'South',
  'South Carolina': 'South',
  Virginia: 'South',
  'District of Columbia': 'South',
  'West Virginia': 'South',
  Alabama: 'South',
  Kentucky: 'South',
  Mississippi: 'South',
  Tennessee: 'South',
  Arkansas: 'South',
  Louisiana: 'South',
  Oklahoma: 'South',
  Texas: 'South',
  // West
  Arizona: 'West',
  Colorado: 'West',
  Idaho: 'West',
  Montana: 'West',
  Nevada: 'West',
  'New Mexico': 'West',
  Utah: 'West',
  Wyoming: 'West',
  Alaska: 'West',
  California: 'West',
  Hawaii: 'West',
  Oregon: 'West',
  Washington: 'West'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/ephtracking-viz/dist/visualizations/regionsLookup.js
// module id = 1292
// module chunks = 0